<template>
    <div id="UserCenterPage" v-wechat-title="'微信营业厅'">
        <!-- <div style="position: relative;">
            <div class="scroll-contail" v-if="message">
                <p class="scroll-text">{{ message }}</p>
                <div class="warning-ico">
                    <van-image width="20px" style="margin-left: 5px;margin-top: 15px;" height="18px" :src="warningIcon" />
                </div>
            </div>
        </div> -->

        <div class="header">
            <!-- <div class="header-title">我的</div> -->
            <ul class="header-content">
                <li class="header-content-item header-content-left">
                    <div class="header-content--img">
                      <img style="width:60px" :src="userInfo.headPortrait ? userInfo.headPortrait : defaultHeadImg" alt="" />
                      <!--   <van-badge position="bottom-right">
                            <van-image round width="60px" height="60px"
                                :src="userInfo.headPortrait ? userInfo.headPortrait : defaultHeadImg" />
                            <template #content>
                                <van-image round width="16px" height="16px"
                                    :src="userInfo.verifiedFlag === 'Y' ? authenticationImg : unAuthenticationImg" />
                            </template>
                        </van-badge> -->
                    </div>
                    <ul>
                        <!-- <li>
                            {{ userInfo.nickname }}
                            <div @click="getToCerti" class="inline-certi">
                                <van-tag round :color="userInfo.verifiedFlag === 'Y' ? '#333333' : '#333333'" size="mini"
                                    :style="{ color: `${userInfo.verifiedFlag === 'N' ? '#FFCE8B' : '#FFCE8B'}` }">
                                    {{ userInfo.verifiedFlag === "Y" ? "已认证" : "未认证" }}
                                </van-tag>
                            </div>
                        </li> -->
                        <li class="info-tell">昵称：{{ userInfo.nickName }}</li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="content">
            <van-cell-group inset>
                <van-cell v-for="(item, index) in menuList" :key="index" size="large" center is-link
                    @click="toItemPage(item.path)">
                    <template #title>
                        <span>{{ item.title }}</span>
                        <!-- <van-badge v-if="item.title === '户号管理' && isNeedUpdate" :dot="true" /> -->
                        <!-- <van-badge v-if="item.title === '户号管理'" /> -->
                    </template>
                    <template #icon>
                        <van-image class="content-icon" width="24px" height="24px" :src="item.icon" />
                    </template>
                </van-cell>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
import { dateIsRefine } from "@/api/business";
import serverconfig from "@/api/server.config";
const CUSTOMRT_TEL = serverconfig.CUSTOMRT_TEL;
import { Dialog,Toast } from 'vant';
import { mapState } from "vuex";
const menuData = [
    {
        title: "户号管理",
        icon: require("../../assets/icon1/userCenter/huhao@2x.png"),
        // path: "/UserCenterPage/ClientCodeManage"
        path: "/WaterAccount/bindCustomer"
    },
    {
        title: "进度查询",
        icon: require("../../assets/icon1/userCenter/shenqing@2x.png"),
        path: "/BusinessManagement"
    },
    {
        title: "我的报装",
        icon: require("../../assets/icon1/mobile_assistant_selected.png"),
        path: "/Business/Expand"
    },
    {
        title: "我的投诉",
        icon: require("../../assets/icon1/notice/qiye@2x.png"),
        path: "/Feedback/MyFeedBack"
    },
    {
      title: "业务咨询",
      icon: require("../../assets/icon1/mobile_assistant_selected.png"),
      path: "/BusinessConsult"
    }

    // {
    //     title: "个人信息",
    //     icon: require("../../assets/icon1/userCenter/xinxi@2x.png"),
    //     path: "/userInfor"
    // },
    // {
    //     title: "户号管理",
    //     icon: require("../../assets/icon1/userCenter/huhao@2x.png"),
    //     path: "/UserCenterPage/ClientCodeManage"
    // },
    /* {
     title: '支付设置',
     icon: require('../../assets/icon1/userCenter/zhifu@2x.png'),
     path: ''
   }, */
    /* {
      title: '我的预约',
      icon: require('../../assets/icon1/userCenter/yuyue@2x.png'),
      path: ''
    }, */
    // {
    //   title: "证件管理",
    //   icon: require("../../assets/icon1/userCenter/zhengjian@2x.png"),
    //   path: ""
    // },
    // {
    //   title: "开票管理",
    //   icon: require("../../assets/icon1/userCenter/kaipiao@2x.png"),
    //   path: "/MakeInvoiceManage/MakeInvoiceList"
    // },
    // {
    //   title: "消息订阅",
    //   icon: require("../../assets/icon1/userCenter/xiaoxi@2x.png"),
    //   path: "/UserCenterPage/MessageSubscription"
    // },
    // {
    //     title: "业务咨询",
    //     icon: require("../../assets/icon1/mobile_assistant_selected.png"),
    //     path: "/UserCenterPage/BusinessConsult"
    // }
    // {
    //   title: "移动助手",
    //   icon: require("../../assets/icon1/userCenter/zhushou@2x.png"),
    //   path: "/UserCenterPage/MobileAssistant"
    // }
    // {
    //     title: "电子合同",
    //     icon: require("../../assets/icon1/userCenter/hetong@2x.png"),
    //     path: "/EContract"
    // },
];

export default {
    name: "",
    data() {
        return {
            menuData,
            userRate: 4.5,
            username: "范德彪",
            userHeadImg: "",
            userState: 0,
            defaultHeadImg: require("../../assets/icon1/userCenter/default_head_img@2x.png"),
            authenticationImg: require("../../assets/icon1/userCenter/header_v@2x.png"),
            unAuthenticationImg: require("../../assets/icon1/userCenter/header_v2@2x.png"),
            clientLists: [],
            isNeedUpdate: false,
            message: '',
            userInfo: {},
            // warningIcon: require("@/assets/background/scroll-warning.png"),
            telPhone: CUSTOMRT_TEL
        };
    },
    computed: {
        // ...mapState("user", {
        //     userInfo: state => state.userInfo ?? {}
        // }),
        menuList() {
            // if (this.$store.state.staff.isHaveMoblie) {
            //     return this.menuData;
            // } else {
            //     let menu = this.menuData.filter(item => item.title !== "移动助手");
            //     return menu;
            // }
            return this.menuData;
        }
    },
    mounted() {
        // this.userId = store.getters.userInfo.userId;
        console.log(this.$store.state.user.userInfo)
        this.userInfo = this.$store.state.user.userInfo;
        // this.selectDateIsRefine();
        // this.message = this.$store.state.app.textConfig.find(val => val.label === "首页游屏显示")?.value
        // if (window.history && window.history.pushState) {
        //     // 往历史记录里面添加一条新的当前页面的url
        //     history.pushState(null, null, document.URL);
        //     // 给 popstate 绑定一个方法 监听页面刷新
        //     window.addEventListener("popstate", this.goBack, false); // false阻止默认事件
        // }
    },
    destroyed() {
        window.removeEventListener("popstate", this.goBack, false); // false阻止默认事件
    },
    methods: {
        // 调用拨号功能
        callPhone() {
            // let tel = this.$store.state.app.textConfig.find(val => val.label === "首页快捷电话")?.value || this.clientTel;
            window.location.href = `tel:${this.telPhone}`;
        },
        goBack() {
            return;
            /* this.$router.replace({
              path: '/'
            }); */
        },
        // 用户认证
        // getToCerti() {
        //     if (this.userInfo.verifiedFlag !== "N") {
        //         return;
        //     }
        //     this.$router.push({ path: "/CertifiedPage" });
        // },
        async toItemPage(path) {
          console.log(path)
            if (path === "/UserCenterPage/MobileAssistant") {
                // await this.$store.dispatch('staff/getStaffToken');
                await this.$store.dispatch("staff/getStaffInfo");
                await this.$router.push({ path });
                // setTimeout(() => {
                //   this.$router.push({ path });
                // }, 200);
            } else if (path === "/Business/Expand") {
                Dialog.confirm({
                  title: ``,
                  message: `暂未开通此功能`,
                  showCancelButton: false,
                  confirmButtonText: '确定',
                  confirmButtonColor: '#3C7EF0'
                });
            }else{
                if (path) {
                    this.$router.push({ path });
                } else {
                    window.location.href = `tel:${this.telPhone}`;
                }
            }
        },

        async selectDateIsRefine() {
            this.clientLists = this.$store.state.user.homeInfo.map(item => {
                return item.clientCode
            })
            const { status, count, resultData } = await dateIsRefine(this.clientLists);
            console.log(JSON.stringify(resultData.data))
            localStorage.setItem('isUpdateUserLists', JSON.stringify(resultData.data));
            resultData.data.forEach((item) => {
                if (item.refine) {
                    this.isNeedUpdate = true;
                    return;
                }
            });
        },
    }
};
</script>

<style lang="less" scoped>
#UserCenterPage {
    position: relative;
    width: 100vw;
    height: 100vh;
    font-size: 14px;
    color: #333;
    background-color: #f1f2f6;

    .scroll-contail {
        position: absolute;
        width: 100%;
        margin: 0;
        // background-image: url('../../assets/background/scroll-bg.png');
        height: 40px;
        padding-top: 0;
        margin-top: -10px;
    }

    .warning-ico {
        float: right;
        background: #83cffb;
        top: 0;
        position: absolute;
        right: 0;
        width: 35px;
        height: 40px;
    }

    .scroll-text {
        white-space: nowrap;
        animation: move 10s infinite linear;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        // font-size: 20px;
        color: #FFFFFF;
        letter-spacing: 0;
    }

    @keyframes move {
        0% {
            transform: translate(100vw, 0);
        }

        100% {
            transform: translate(calc(-100%), 0);
        }
    }

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 160px;
        color: #fff;
        background-image: url("../../assets/icon1/userCenter/back_head@2x.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &-title {
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 18px;
        }

        &-content {
            width: 100%;
            height: 70px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;

            &-item {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &-left {
                ul {
                    padding-left: 20px;

                    li:first-child {
                        margin-bottom: 8px;
                        font-family: PingFangSC-Medium;
                        font-weight: 500;
                        font-size: 18px;
                        color: #FFFFFF;
                    }

                    .info-tell {
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                    }
                }

                .inline-certi {
                    display: inline-block;
                    margin-left: 8px;
                }

                .van-tag {
                    padding: 3px 12px;
                }

                /deep/ .van-button--mini {
                    height: 20px;
                }

                /deep/ .van-badge {
                    background-color: transparent;
                    border: none;
                }

                /deep/ .van-badge--fixed {
                    top: auto;
                    bottom: -10px;
                    right: 10px;
                }
            }

            &-right {
                flex-direction: column;

                div:first-child {
                    margin-bottom: 8px;
                }
            }
        }
    }

    .content {
        // position: absolute;
        margin-top: 12px;
        top: 140px;
        width: 100%;
        font-size: 16px;
        font-family: PingFangSC-Regular;

        /deep/ .van-badge {
            margin-left: 12px;
        }

        &-icon {
            margin-right: 14px;
        }

        .van-cell {
            line-height: 34px;
        }

        .van-cell-group--inset {
            margin: 0 12px;
        }

        .van-cell__title {
            color: #333;
        }
    }

    .content2 {
        position: relative;
        top: 12px;

        /deep/ .van-badge {
            margin-left: 12px;
        }

        &-icon {
            margin-right: 14px;
        }

        .van-cell {
            line-height: 34px;
        }

        .van-cell-group--inset {
            margin: 0 12px;
        }

        .van-cell__title {
            color: #333;
        }
    }
}
</style>
